import { createSlice } from "@reduxjs/toolkit";

const empSalarySlice = (name, defaultSortField = "created", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: (state) => Object.assign(state, initialState)
    },
  });

  return slice;
};

// Create specific slices
export const salarySlice = empSalarySlice("salary", "salaryAmount", "desc");
export const salaryDetailSlice = empSalarySlice("salaryDetail", "created", "desc");

// Export reducers for store
export const financeReducers = {
  salary: salarySlice.reducer,
  salaryDetail: salaryDetailSlice.reducer,
};
